// CreateOrderButton.jsx
import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useParams } from "react-router-dom";
import {  Link  } from "react-router-dom";
import { useSelector } from "react-redux"
export default function CreateOrderButton() {
  const [loading, setLoading] = useState(false);
    const currentToken = useSelector((state)=>state?.user?.user?.token);
    const user_email = useSelector((state)=>state?.user?.user?.user_email
   );
   const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
   const appId = useSelector((state)=>state?.app?.app?.ID);
  
  async function handleCreateOrder() {
    setLoading(true);
    try {
      // 1) Call WP REST endpoint to create Razorpay order

      
      const resp = await fetch('https://ilogically.com/wp-json/classmock/v1/razorpayPaymentAPI', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({ amount: 100,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
         appToken:AppToken,appId:appId }) // ₹1000
      });
     
      const data = await resp.json();
       console.log(data)
      if (!resp.ok) throw new Error(JSON.stringify(data));

      const { razorpay_key_id, razorpay_order_id, amount, currency } = {
        razorpay_key_id: data.razorpay_key_id, // fallback below if formatting issue
        razorpay_order_id: data.razorpay_order_id,
        amount: data.amount,
        currency: data.currency
      };

      // 2) dynamically load Razorpay checkout script if not already loaded
      await loadRazorpayScript();

      // 3) open checkout
      const options = {
        key: data.razorpay_key_id, // public/key_id
        amount: data.amount, // amount in paise
        currency: data.currency,
        name: 'Classmock (Test)',
        description: 'Test order',
        order_id: data.razorpay_order_id,
        
        handler: function (response) {
          // response contains razorpay_payment_id, razorpay_order_id, razorpay_signature
          console.log( response);
          // send response to server to verify signature & record payment
          // POST /wp-json/classmock/v1/verify-payment  (you should implement)
        },
        prefill: {
          name: '',
          email: ''
        },
        notes: {
          // optional
        },
        theme: {
          color: '#3399cc'
        }
      };
      const rzp = new window.Razorpay(options);
      rzp.open();
      setLoading(false);
    } catch (err) {
      console.error(err);
      alert('Create order failed: ' + err.message);
      setLoading(false);
    }
  }

  function loadRazorpayScript() {
    return new Promise((resolve, reject) => {
      if (window.Razorpay) return resolve();
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Razorpay SDK failed to load.'));
      document.body.appendChild(script);
    });
  }

  return (
    <button onClick={handleCreateOrder} disabled={loading}>
      {loading ? 'Creating order...' : 'Pay ₹1000 (test)'}
    </button>
  );
}